import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { LuChevronRight } from "react-icons/lu";
import { Link as ReactRouterLink } from "react-router-dom";
import { useShopContext } from "../shop";
import { isFeatureEnabled } from "../utils/featureFlag";

type SettingsProps = {
  label: string;
  to: string;
};

function SettingLink({ label, to }: SettingsProps) {
  return (
    <Flex asChild p={2} textAlign="left" justify="space-between">
      <ReactRouterLink to={to}>
        <Text>{label}</Text>
        <LuChevronRight style={{ fontSize: "24px" }} />
      </ReactRouterLink>
    </Flex>
  );
}

export function Settings() {
  const { currentShopId } = useShopContext();

  return (
    <>
      <Heading fontSize="lg" textAlign="left" p={2}>
        設定
      </Heading>
      <Heading fontSize="md" textAlign="left" p={2}>
        商品登録・出品設定
      </Heading>
      <VStack align="stretch" gap={0} separator={<Box borderBottomWidth="1px" borderBottomColor="gray.200" />}>
        {isFeatureEnabled("categories", { shopId: currentShopId ?? undefined }) && (
          <SettingLink label="カテゴリー設定" to="/settings/categories" />
        )}
        {isFeatureEnabled("templates", { shopId: currentShopId ?? undefined }) && (
          <SettingLink label="テンプレート設定" to="/settings/templates" />
        )}
        <SettingLink label="プラットフォーム固有の設定" to="/settings/platforms" />
      </VStack>
    </>
  );
}
